<template>
  <div id="app" class="App" :class="themeClass">

    <transition name="App-">

      <router-view></router-view>

    </transition>

  </div>
</template>

<script>
// import Socket from 'socket.io-client'

// const websocketHost = 'http://localhost:8081'

export default {
  name: 'App',

  computed: {
    initialized () { return this.$store.state.initialized },
    suite () { return this.$store.state.suite },
    animal () { return this.$store.state.animal },
    dataRefreshTimestamp () { return this.$store.state.dataRefreshTimestamp },
    suiteColors () { return this.$store.state.settings.suiteColors },
    idleTime () { return this.$store.state.idleTime },

    themeClass () {
      return `theme-${this.suiteColors[this.suite.suiteNumber]}`
    }
  },

  watch: {
    initialized () {
      this.$nextTick(() => {
        // 10/15/2019: moved this out of the boot method so that it only happens once on load
        // 1/17/2020: moved this after initialization–was happening before animal was loaded for some reason
        this.$store.dispatch('loadRecentlyAdopted')
      })
    },

    suite () {
      // When no animals are assigned to a suite in the CMS, one of these IDs is
      // automatically assigned for API output.
      const unoccupiedAnimalIds = [
        'animal-unoccupied-dog',
        'animal-unoccupied-cat',
        'animal-unoccupied-other'
      ]

      // console.log('suite update')

      // Test for an unnocupied animal id
      const hasUnoccupiedAnimalID = unoccupiedAnimalIds.includes(this.suite.animalIds[0])

      // Test for no animal ids at all, in case an unoccupied animal ID was not
      // sent through the API for some reason
      const noAnimalIds = !this.suite.animalIds.length

      // Show the About view if suite is unoccupied
      if (hasUnoccupiedAnimalID || noAnimalIds) {
        this.$router.push({
          name: 'about'
        })

        // Flag suite as 'unoccupied'
        this.$store.dispatch('setSuiteIsUnoccupied', true)
      }
    },

    /**
     * Listen for data refresh event, reboot
     */
    dataRefreshTimestamp () {
      this.load()
    }

    /**
     * When app idles out, show attract mode
     */
    // idleTime () {
    //   if (!this.animal) return
    //   this.$router.push({
    //     name: 'attract'
    //   })
    //
    //   // Reboot
    //   // this.load()
    // }
  },

  created () {
    // this.handleWebSockets()
    this.startIdleTimer()

    this.load()
  },

  methods: {
    /**
     * Get initial state based on suite ID
     */
    load () {
      this.$store.dispatch('load', {
        suiteId: this.$route.params.suiteId,
        animalIndex: this.$route.params.animalIndex
      })

      this.resetIdleTimer()
    },

    /**
     * Start idle timer
     */
    startIdleTimer () {
      document.addEventListener('touchstart', this.resetIdleTimer)
      // this.resetIdleTimer()
    },

    /**
     * Reset idle timer
     */
    resetIdleTimer () {
      // Clear exisiting timer
      if (this.timer) clearTimeout(this.timer)

      const time = new Date().getTime()

      // Save timestamp of touch event
      this.$store.dispatch('setLastTouchTimestamp', time)

      // Create a new timer
      this.timer = setTimeout(() => {
        // When timer expires, trigger idle event
        this.$store.dispatch('setIdleTime', time)
      }, 90000)
    }
  }
}
</script>

<style>
.App {
  position: relative;
  width: 1080px;
  height: 1920px;
  -webkit-touch-callout:none;
  -webkit-user-select:none;
  -khtml-user-select:none;
  -moz-user-select:none;
  -ms-user-select:none;
  user-select:none;
  -webkit-tap-highlight-color:rgba(0,0,0,0);
  color: var(--color-4);
  background-image: linear-gradient(to bottom, var(--color-gradient-start) 16.88%, 63.4%, var(--color-gradient-end) 100%);
}

.App--enter-active,
.App--leave-active {
  transition: opacity 1s ease;
}

.App--enter,
.App--leave-active {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// App.vue?1c9265f5